import { render } from "./ReservationsList.vue?vue&type=template&id=5292e30c&scoped=true"
import script from "./ReservationsList.vue?vue&type=script&lang=js"
export * from "./ReservationsList.vue?vue&type=script&lang=js"

import "./ReservationsList.vue?vue&type=style&index=0&id=5292e30c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5292e30c"]])

export default __exports__